// eslint-disable-next-line import/prefer-default-export
export const getBusinessUnitFromWeddingsRoute = path => {
  let businessUnit = 'WEDDING_PLANNING';
  if (path.indexOf('wedding/manage/guests') > -1) businessUnit = 'WEDDING_GUEST_LIST';
  if (path.indexOf('wedding/manage/website') > -1) businessUnit = 'WEDDING_WEBSITE';
  if (path.indexOf('wedding/manage/wedding-checklist') > -1) businessUnit = 'WEDDING_CHECKLIST';
  return businessUnit;
}


// WEBPACK FOOTER //
// ./src/routesHelpers.js